@if (data && data.iframe_data) {
    <app-iframe [isChildComponent]="true" [enhancedArticleProps]="data.iframe_data" (closeEvent)="close($event)"> </app-iframe>
}

@if (schedule_entries.length) {
    <div class="related-entries">
        @for (item of schedule_entries; track item; let i = $index) {
            <app-scheduled-entry
                (click)="openScheduleEntry(item.id)"
                [margin_bottom]="i === schedule_entries.length - 1 ? '0em' : '1em'"
                [entry]="item"
                [attr.data-schedule-entry-id]="item.id"
            ></app-scheduled-entry>
        }
    </div>
}

@if (article_players && article_players.length > 0) {
    <div class="tagged-players">
        @for (player of article_players; track player) {
            <div>
                <div class="article-player" (click)="openPlayer(player)">
                    <app-image [display_flag]="true" [app_country_flag_width]="'1em'" [player]="player" [margin]="'0'" [width]="'52px'" [height]="'52px'"></app-image>
                    <div style="margin-left: 15px">{{ player.first_name }} {{ player.last_name }}</div>
                </div>
            </div>
        }
    </div>
}

<div class="share-container">
    <div class="item"><span>Published on:</span> {{ getArticlePublicationDate() }}</div>
    <div class="buttons-container">
        <button mat-flat-button (click)="shareArticle()">
            <mat-icon>share</mat-icon>
            <span>
                <!-- <app-app-string class="label" [key_name]="'articles.share'"></app-app-string> -->
            </span>
        </button>
        <button mat-flat-button (click)="likeArticle()" [ngStyle]="likedArticle()">
            <!-- <img src="assets/liked1.png" alt="likes" style="margin-right: 0.4em" *ngIf="article && article.current_fan_liked" />
      <img src="assets/like.png" alt="likes" style="margin-right: 0.4em" *ngIf="article && !article.current_fan_liked" /> -->
            <mat-icon>thumb_up</mat-icon>
            <span style="margin-right: 0.4em">{{ getArticleLikes() }}</span>
        </button>
    </div>
</div>

<div class="comments-container">
    <div class="banner">
        <div style="width: 90%; text-align: center">
            @if (data.card) {
                @if (video_ad_sponsor) {
                    <app-rotating-sponsors [video_ad_sponsor]="video_ad_sponsor" [card]="data.card" default_aspect_ratio="9:1"></app-rotating-sponsors>
                } @else {
                    <app-rotating-sponsors default_aspect_ratio="9:1" [card]="data.card"></app-rotating-sponsors>
                }
            }
        </div>
    </div>

    <div class="login-container" [ngStyle]="{ 'justify-content': isLoggedIn() && !loading ? 'flex-start' : 'center' }">
        @if (isLoggedIn() && !loading && captchaSuccess) {
            <div class="comment-box">
                <img [src]="loggedUserProfileImage" alt="profileImg" />
                <div class="input-wrapper">
                    <textarea
                        type="text"
                        [placeholder]="appStringAPI.getAppString('articles.comments.placeholder')"
                        [formControl]="comment"
                        maxlength="255"
                        (keydown.enter)="publish()"
                    ></textarea>
                </div>
                @if (isLoggedIn() && !loading) {
                    <div class="send-area">
                        <button mat-icon-button [disabled]="comment.value.trim().length === 0"><mat-icon>send</mat-icon></button>
                        <!-- <button mat-icon-button (click)="publish()" [disabled]="comment.value.trim().length === 0">
            <mat-icon style="font-size: 1rem">send</mat-icon>
          </button> -->
                        <div class="char-counter">{{ comment.value.length }}/255</div>
                    </div>
                }
            </div>
        }

        @if (isLoggedIn() && !loading && !captchaSuccess) {
            <div class="captcha">
                <div class="row">
                    <div class="captcha-form">
                        @if (verifying_captcha) {
                            <mat-spinner [diameter]="30" style="margin: 0.5rem"></mat-spinner>
                        }
                        @if (!verifying_captcha) {
                            <button mat-flat-button type="button" (click)="verifyRecaptcha()">Verify to post a comment</button>
                        }
                    </div>
                </div>
            </div>
        }

        @if (!isLoggedIn() && !loading) {
            <button mat-flat-button (click)="login()">
                <mat-icon>account_circle</mat-icon>
                <span>
                    {{ getAppString('articles.auth') }}
                    <!-- <app-app-string class="label" [key_name]="'articles.auth'"></app-app-string> -->
                </span>
            </button>
        }
    </div>

    @for (comment of comments; track comment) {
        <div class="comments">
            <div style="display: flex; flex-direction: column">
                <div class="profile-img">
                    <img [src]="getAvatarUrl(comment)" (error)="onImgError($event)" alt="profileImg" />
                </div>
                <div></div>
            </div>
            <div class="comment-content">
                <div class="name">
                    <div>
                        <div style="font-weight: 900">{{ getFanName(comment) }}</div>
                        <div class="content">{{ comment.content }}</div>
                    </div>
                    <div class="like">
                        <button mat-icon-button (click)="likeArticleComment(comment.id)"><mat-icon>thumb_up</mat-icon></button>
                        <button mat-icon-button (click)="dislikeArticleComment(comment.id)"><mat-icon>thumb_down</mat-icon></button>
                        <div [ngStyle]="{ visibility: comment?.likes !== 0 ? 'visible' : 'hidden' }" class="number-likes">Likes: {{ comment.likes }}</div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
